module.exports = __webpack_public_path__ + "static/media/Asset-17.955f0e28.svg";